import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconRemoveBackground: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="remove-background"><path d="M20.25 3.75H3.75V20.25H20.25V3.75Z" stroke="currentColor" strokeWidth="1.5"/><circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.5"/><path d="M14.5 9.5L20 4" stroke="currentColor" strokeWidth="1.5"/><path d="M9.5 14.5L4 20" stroke="currentColor" strokeWidth="1.5"/><path d="M3.75 11.25L11.25 3.75" stroke="currentColor" strokeWidth="1.5"/><path d="M12.75 20.25L20.25 12.75" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconRemoveBackground;
